import { trending } from "../../../mocks/gossip";

const RANK_BG = [
  "bg-primary-600",
  "bg-primary-500",
  "bg-accent-500",
];

export default function RankSection() {
  return (
    <section id="rank" className="scroll-mt-20 bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-5xl px-4 md:px-8 py-10 md:py-14">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-700 px-3 py-1 text-xs font-medium mb-3">
            <i className="ri-fire-fill" aria-hidden="true"></i> 此刻热搜
          </span>
          <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">全网热搜榜 · TOP10</h2>
          <p className="text-foreground-500 text-sm mt-1.5">微博 / 豆瓣 / 知乎 / 公众号 / 天涯 / 贴吧 实时热度汇总</p>
        </div>

        <ol className="space-y-2.5">
          {trending.map((item, i) => (
            <li
              key={i}
              className="group flex items-center gap-4 rounded-xl bg-background-50 px-4 py-3 hover:shadow-sm hover:-translate-y-0.5 transition"
            >
              <span
                className={`w-7 h-7 shrink-0 rounded-lg text-background-50 text-sm font-bold flex items-center justify-center ${
                  i < 3 ? RANK_BG[i] : "bg-background-300 text-foreground-700"
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-foreground-900 font-medium text-sm sm:text-base leading-snug line-clamp-2 group-hover:text-primary-700 transition">{item.title}</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-community-line" aria-hidden="true"></i>
                    {item.platform}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    <i className="ri-fire-fill text-[13px]" aria-hidden="true"></i>
                    {item.heat}
                  </span>
                </div>
              </div>
              <span
                className={`hidden sm:inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium ${
                  item.trend === "up" ? "bg-accent-50 text-accent-700" : "bg-background-100 text-foreground-500"
                }`}
              >
                <i className={item.trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"} aria-hidden="true"></i>
                {item.trend === "up" ? "上升中" : "回落"}
              </span>
            </li>
          ))}
        </ol>

        <p className="text-center text-xs text-foreground-400 mt-6">
          热度数据为演示示例，实时热搜请以各平台官方榜单为准。
        </p>
      </div>
    </section>
  );
}